<template>
  <div class="line-bg">
    <div class="title-content">
      <h3>{{ title[0] }}</h3>
      <p>{{ title[1] }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Title",
  props: {
    title: Array
  }
};
</script>

<style lang="scss" scoped>
.line-bg {
  margin-bottom: 20px;
  background: url(data:image/png;base64,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)
    0px 30px no-repeat;
}
.title-content {
  position: relative;
  top: -20px;

  h3 {
    margin-bottom: 0;
    text-align: left;
    font-weight: 540;
    color: #477dbf;
  }

  p {
    margin: 0;
    text-align: left;
    color: #cbcbcb;
  }
}
</style>
